import { getApi } from "./api_instance";

export const getAllSDG = async (logout) => {
  try {
    const { data } = await getApi({
      apiUrl: "/admin/projects/api/sdg/list",
      logout,
    });
    return data;
  } catch (error) {
    return error;
  }
};
